import { fetchQuery, graphql } from "relay-runtime"
import {
  chTranslateQuery as chTranslateQueryType,
  TranslateInput,
} from "@/modules/chats/services/ai/ch/__generated__/chTranslateQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chTranslateQuery($input: TranslateInput!) {
    translate: ch_translate(input: $input) {
      ...TextResultFragment @relay(mask: false)
    }
  }
`

export const chTranslateQuery = (input: TranslateInput) => {
  return fetchQuery<chTranslateQueryType>(RelayEnvironment, query, { input }).toPromise()
}
